<div class="product-master-container">
  <!-- Header Section -->
  <div class="page-header-section">
    <div class="header-content">
      <div class="header-text">
        <div class="breadcrumb-badge">
          <i class="fa fa-chart-bar"></i>
          <span>Reports</span>
        </div>
        <h1 class="page-title">Product Master Report</h1>
        <p class="page-subtitle">Comprehensive Hero Ensure plan details with role-based column visibility</p>
      </div>
      <div class="header-actions">
        <button 
          class="btn btn-action btn-export"
          type="button"
          [disabled]="loading"
          title="Export data as CSV"
          (click)="exportToCSV()">
          <span class="btn-icon"><i class="fa fa-download"></i></span>
          <span>Export CSV</span>
          <span *ngIf="loading" class="spinner-border spinner-border-sm"></span>
        </button>
      </div>
    </div>

    <!-- Stats Section -->
    <div class="header-stats" *ngIf="!loading && plans.length > 0">
      <div class="stat-card">
        <div class="stat-icon"><i class="fa fa-list"></i></div>
        <div class="stat-content">
          <span class="stat-label">Total Plans</span>
          <span class="stat-value">{{ filteredPlans?.length || plans.length }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Toolbar Section -->
  <div class="toolbar-section" *ngIf="!loading && plans.length > 0">
    <div class="toolbar-left">
      <div class="search-box">
        <i class="fa fa-search"></i>
        <input 
          type="text" 
          placeholder="Search plans by Plan ID..."
          class="search-input"
          (input)="onSearchChange($event)">
      </div>
    </div>
    <div class="toolbar-right">
      <div class="page-size-selector">
        <label>Rows per page:</label>
        <select class="page-size-select" (change)="onPageSizeChange($event)">
          <option value="5">5</option>
          <option value="10" selected>10</option>
          <option value="20">20</option>
          <option value="50">50</option>
        </select>
      </div>
      <button class="btn btn-action btn-secondary" title="Refresh data" (click)="refreshData()">
        <i class="fa fa-refresh"></i>
      </button>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="loading-state">
    <div class="loading-spinner">
      <div class="spinner-border" role="status"></div>
      <p>Loading product master data...</p>
    </div>
  </div>

  <!-- Empty State -->
  <div *ngIf="!loading && plans.length === 0" class="empty-state">
    <div class="empty-icon">
      <i class="fa fa-inbox"></i>
    </div>
    <h3>No Plans Found</h3>
    <p>No hero plans found in the system. Please ensure plans are marked as "Hero Ensure" in the Plan Catalogue.</p>
  </div>

  <!-- Data Grid -->
  <div *ngIf="!loading && plans.length > 0" class="grid-container">
    <div class="grid-wrapper">
      <ag-grid-angular
        #agGrid
        class="ag-theme-quartz professional-grid"
        [columnDefs]="columnDefs"
        [rowData]="filteredPlans"
        [gridOptions]="gridOptions"
        (gridReady)="onGridReady($event)"
      ></ag-grid-angular>
    </div>
  </div>
</div>
